<template>
  <!-- act-item .pi -->
  <div>
    <div v-if="ActData.length">
      <div class="pi">
        <div class="pi-wrap" v-for="(item, index) in ActData" :key="'act-item-' + index">
          <div class="wrap" @click="linkToAct(item)">
            <div class="photo">
              <img :src="item.banner[0]" alt="" v-if="item.banner[0]">
              <img src="@/assets/img/empty.png" alt="" v-else>
            </div>
            <div class="title">
              <h3>{{item.name}}</h3>
              <p style="padding-left: 12px;" class="title-line" v-if="item.address">
                <i class="icon iconfont icon-changyongdizhi" style="color: rgb(209, 49, 25);"></i>
                <span style="padding-left: 0px;">{{item.address}}</span>
              </p>
              <p style="padding-left: 12px;" class="title-line">
                <i class="icon iconfont icon-shafa" style="color: #329bba;"></i>
                <span>{{ item.startTime | moment('YYYY/MM/DD') }} ~ {{ item.endTime | moment(' MM/DD') }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="m-page" v-if="totalCount > 20">
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </div>
    <div class="no-msg" v-else>
        No Data
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "act-item",
  props:['topic'],
  data() {
    return {
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0, // 总数据
      ActData:[],
      // topic: -1, // -4：免费报名，-3：新发布，-2：热搜，-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"
      donetTip: false, //数据是否加载完毕
      searchContent:'',
    };
  },
  components: {},
  computed: {
    ...mapGetters({
        exhibitionId:'getExhibitionId'
    }),
    condition() {
      //分页获取条件
      return {
        ExhibitionId: this.exhibitionId,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: "%" + this.searchContent + "%"
                }
              }
            ]
          }
        }
      };
    }
  },
  watch:{
    topic(val){
      this.select(val);
    }
  },
  created(){
    this.init();

  },
  methods: {
    init() {
      this.getActList();
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      console.log("changePage: ", e);
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      console.log("changePageSize: ", e);
    },
    linkToAct(item){
      // console.log(item,'item');
      this.$router.push(`/activity-detailsEn/${item.id}?compId=${item.compId}`);
    },
    async getActList() {
      this.ActData = [];
      this.donetTip = false;
      await this.$service.getActList(this, this.condition, this.topic);
    },
    select(type) {
      this.pageIndex = 1;
      this.pageSize = 20;
      this.topic = type;
      this.getActList();
    },
  },
};
</script>

<style scoped lang="scss">
.m-page {
  padding-bottom: 50px;
  text-align: center;
}
.pi {
  margin-top: 20px;
  margin-bottom: 50px;
  overflow: hidden;
  &-wrap {
    cursor: pointer;
    display: block;
    width: 25%;
    float: left;
    background-color: #f5f5f5;
    overflow: hidden;
    padding-bottom: 10px;
    padding-right: 20px;
    color: #ccc;
    &:nth-of-type(4n) {
      padding-right: 0px;
    }
  }
}
</style>
<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.wrap {
  width: 100%;
  height: 299px;
  border-radius: 3px;
  background-color: #fff;
  position: relative;
  margin-bottom: 20px;
  cursor: pointer;
}
.wrap .photo {
  height: 190px;
  overflow: hidden;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  img {
    width: 100%;
    height: 100%;
  }
}
.wrap .title {
  height: 109px;
  overflow: hidden;
}
.wrap .title h3 {
  font-size: 14px;
  padding: 0 14px;
  color: #333;
  line-height: 18px;
  margin-bottom: 11px;
  margin-top: 20px;
  @include text-ellipsis();
}
.wrap .title {
  span {
    font-size: 14px;
    color: #999;
    line-height: 26px;
    padding-left: 4px;
  }
  .title-line {
    display: flex;
    align-items: center;
    span {
      width: calc(100% - 1px);
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.wrap .icon2 {
  min-width: 68px;
  height: 24px;
  background-color: #1890ff;
  border-radius: 2px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 172px;
  left: 14px;
  padding: 0 4px;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.no-msg{
  height: 200px;
  line-height: 200px ;
  text-align: center;
  width: 100%;
  display: table;
}
</style>
